"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HeadingSection_1 = require("./HeadingSection");
Object.defineProperty(exports, "HeadingSection", { enumerable: true, get: function () { return HeadingSection_1.HeadingSection; } });
//# sourceMappingURL=index.js.map